<script lang="ts">
import {defineComponent, PropType} from "vue";
import ModalDialog from "../ob1/ModalDialog.vue";
import Price from "../ob1/Price.vue";
import {Gallery, Section} from "../../../orange/broadband/internet/showcase/components/models/SingleOfferDetail";

export default defineComponent({
    name: "OptionEditoPopin",
    components: {ModalDialog, Price},
    props: {
        popinId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object as PropType<Gallery | null>,
            required: false,
            default: null
        },
        sections: {
            type: Array as PropType<Array<Section>>,
            required: true
        },
        mentions: {
            type: Object as PropType<string | null>,
            required: false,
            default: null
        },
        price: {
            type: Number,
            required: true
        },
        alertMessage: {
            type: Object as PropType<string | null>,
            required: false,
            default: null
        },
    },
});
</script>

<template>
    <modal-dialog
        :id="popinId"
        :modal-button-label="'Fermer'"
        :action-label="'Ouvrir'"
        :modal-title="title"
        :alert-html-content="alertMessage"
    >
        <template #modalBody>
            <div class="d-flex flex-wrap flex-md-nowrap my-1">
                <template v-if="visual">
                    <div class="flex-fill me-1 order-0">
                        <img :src="visual.url" :alt="visual.alt || ''" />
                    </div>
                </template>
                <div class="flex-fill mt-1 mt-md-0 me-md-1 order-2 order-md-1">
                    <template v-for="section in sections">
                        <h5 class="lead mb-1 pb-0" v-html="section.title" />

                        <div v-if="section.icon" class="col-12">
                            <span :class="section.icon" class="icon h1 align-self-center text-primary3"></span>
                            <p class="ms-1" v-html="section.paragraph" />
                        </div>
                        <p v-else class="m-0" v-html="section.paragraph" />
                    </template>
                </div>
                <div class="flex-fill-end order-1 order-md-2">
                    <Price :price="price" :show-by-month="true" />
                </div>
            </div>
            <p v-if="mentions" class="font-size-12" v-html="mentions" />
        </template>
    </modal-dialog>
</template>
